export const extend = (target, source) => {
  for (let key in source) {
    target[key] = source[key]
  }
  return target
}



// WEBPACK FOOTER //
// ./src/components/progressbar/vue-progress/utils.js